import { render, staticRenderFns } from "./customerFeedback.vue?vue&type=template&id=4cd2c6ef&scoped=true&"
import script from "./customerFeedback.vue?vue&type=script&lang=ts&"
export * from "./customerFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./customerFeedback.vue?vue&type=style&index=0&id=4cd2c6ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd2c6ef",
  null
  
)

export default component.exports